import { trackWebVitals } from "../src/client/utils/tracking";
import Page from "./../src/client/pages/_app";
export default Page;

export function reportWebVitals(metric) {
  trackWebVitals(metric);
}
